import React, { FC, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { locationsRestCrudThunksForBuyer } from '../../thunks/locations_thunks';
import { Button, Form, message, Modal, Select } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { patchUpdateACCAuditForMissingAsset } from '../../thunks/acc_audits_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';

const FORM_NAME = 'acc_audit_transfer_form';

const ACCAuditTransferModal: FC<any> = ({
	accAudit,
	onCancel,
	onSuccess,
	locations,
	fetchLocations,
	fetchMultipleLocations,
	accRun,
	updateMissingAssetAction,
}): React.ReactElement => {
	const [form] = useForm();

	const [updating, setUpdating] = useState(false);

	const onSubmit = useCallback(
		(values) => {
			setUpdating(true);
			updateMissingAssetAction(accAudit.assetCycleCountRunId, accAudit.assetId, {
				missingAssetAction: 'transfer',
				...values,
			})
				.then(() => onSuccess())
				.catch(message.error)
				.finally(() => setUpdating(false));
		},
		[accAudit, onSuccess, updateMissingAssetAction]
	);

	return (
		<Modal
			visible={true}
			width={600}
			title={`Transfer`}
			closable
			onCancel={onCancel}
			forceRender
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_NAME}
					loading={updating}
				>
					Mark to transfer
				</Button>,
			]}
		>
			<Form form={form} id={FORM_NAME} layout="vertical" requiredMark={false} onFinish={onSubmit}>
				<Form.Item
					name="transferToLocationId"
					label="Location"
					rules={[
						{
							required: true,
							message: 'Please select a location!',
						},
					]}
				>
					<OWAsyncSelect
						stateSlice={locations}
						valueAccessor={(el) => el.id}
						targetCollectionName={'addPartsDropdown'}
						fetchData={(
							name,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
						) =>
							fetchLocations(
								{
									name: name || undefined,
								},
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							)
						}
						fetchMultiple={(ids, targetCollectionName) => {
							fetchMultipleLocations(ids, targetCollectionName);
						}}
						renderRecord={(l) => (
							<Select.Option key={l.id} value={l.id} disabled={l.id === accRun.locationId}>
								<div>{l.name}</div>
								<div style={{ color: 'rgba(0,0,0,0.45)' }}>
									{nullSafeGet('buyerFacility.primaryAddress.streetAddress1', l)},{' '}
									{nullSafeGet('buyerFacility.primaryAddress.city', l)}{' '}
									{nullSafeGet('buyerFacility.primaryAddress.region', l)}
								</div>
							</Select.Option>
						)}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	locations: state.locations,
});

const mapDispatchToProps = (dispatch) => ({
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForBuyer.readLite(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	updateMissingAssetAction: (accRunId, assetId, entity) =>
		dispatch(patchUpdateACCAuditForMissingAsset(ROLE_TYPES.BUYER)(accRunId, assetId, entity)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(ACCAuditTransferModal as any)
);
